import React from 'react';

export const EditIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16">
    <path d="M13,1.57l-.29-.29L4.16,9.81h0l2.75,2.75L13,6.5A3.48,3.48,0,0,0,13,1.57Z" />
    <path d="M2.85,11.12,2,14.06a.52.52,0,0,0,.5.66l.14,0,2.94-.83.33-.33h0L3.18,10.79Z" />
  </svg>
);
